import React from "react";
import WarningTriangle from "../../assets/Icons/WarningTriangle";
import "./QualityFrameworkAccessDenied.scss";

export const QualityFrameworkAccessDenied = ({ onBack }) => (
  <div className="qf-access-denied" data-testid="qf-access-denied">
    <WarningTriangle width={22} height={22} color="#FF9831" />
    <p>
      You do not have access to Quality Framework. Please contact your
      administrator.
    </p>
    
  </div>
);

export default QualityFrameworkAccessDenied;
